import { render, staticRenderFns } from "./DynamicPhoneField.vue?vue&type=template&id=77522cf6&"
import script from "./DynamicPhoneField.vue?vue&type=script&lang=js&"
export * from "./DynamicPhoneField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPhoneField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
